import { ApplicationRef, ComponentRef, createComponent, EnvironmentInjector, Injectable, Type } from '@angular/core';
import { IModalOptions } from '../models/modal.interfaces';

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  private _modalQueue: ComponentRef<any>[] = [];
  private _activeModal!: ComponentRef<any>;

  static instance: ModalService;

  constructor(
    private _appRef: ApplicationRef,
    private _injector: EnvironmentInjector,
  ) {
    if (!ModalService.instance) {
      ModalService.instance = this;
    }

    return ModalService.instance;
  }

  public show(component: Type<any>, options?: Partial<IModalOptions>) {
    const modal = createComponent(component, {
      environmentInjector: this._injector,
    });

    if (options?.title) {
      modal.instance.title = options.title;
    }

    if (options?.context) {
      Object.entries(options.context).forEach(([key, value]) => {
        modal.instance[key] = value;
      })
    }

    if (options?.width) {
      modal.instance.width = options.width;
    }

    if (options?.height) {
      modal.instance.height = options.height;
    }

    this._modalQueue.push(modal);
    this._activeModal = modal;

    this._activateModal();

    return {
      containerRef: modal,
      onClose: modal.instance.closeHandle,
    };
  }

  public hide(componentRef?: ComponentRef<any>) {
    if (componentRef) {
      const refIndex = this._modalQueue.findIndex(modalRef => modalRef === componentRef);
      const modalRefs = this._modalQueue.splice(refIndex);
      modalRefs.forEach(mRef => mRef.destroy());
      return;
    }

    const modalRef: ComponentRef<any> | undefined = this._modalQueue.pop();
    modalRef?.destroy();

    this._activeModal = this._modalQueue.slice(-1)[0];
    this._activateModal();
  }

  public hideAll(): void {
    this._modalQueue.forEach(modalRef => {
      this.hide(modalRef);
    });
  }

  private _activateModal() {
    if (!this._activeModal) {
      return;
    }

    document.body.appendChild(this._activeModal.location.nativeElement);
    this._appRef.attachView(this._activeModal.hostView);
  }
}
